import image0 from './image/Designer0.png';
import image1 from './image/Designer1.png';
import image2 from './image/Designer2.jpg';
import image3 from './image/Designer3.png';
import image4 from './image/Designer4.jpg';
import image5 from './image/Designer5.jpg';
import image6 from './image/Designer6.jpg';
import image7 from './image/Designer7.png';
import image8 from './image/Designer8.jpg';
import image9 from './image/Designer9.jpg';
import image10 from './image/Designer10.jpg';
import image11 from './image/Designer11.jpg';
import image12 from './image/Designer12.jpg';
import image13 from './image/Designer13.png';
import image14 from './image/Designer14.jpg';
import image15 from './image/Designer15.jpg';
import image16 from './image/Designer16.jpg';
import image17 from './image/Designer17.jpg';
import image18 from './image/Designer18.jpg';
import image19 from './image/Designer19.png';

const samples = [
  {
    promptText: _TL_('Modern high-tech gadgets on a sleek, minimalist desk.'),
    imageSrc: image0,
  },
  {
    promptText: _TL_('A luxury car driving through scenic mountains.'),
    imageSrc: image1,
  },
  {
    promptText: _TL_('A digital timer displayed prominently on a sleek marble surface.'),
    imageSrc: image2,
  },
  {
    promptText: _TL_('An array of high-end skincare products on a marble countertop.'),
    imageSrc: image3,
  },
  {
    promptText: _TL_('An electric bicycle displayed next to an outdoor café.'),
    imageSrc: image4,
  },
  {
    promptText: _TL_('A stylish home office setup with tech gadgets.'),
    imageSrc: image5,
  },
  {
    promptText: _TL_('A picnic setup with food and decor in a park.'),
    imageSrc: image6,
  },
  {
    promptText: _TL_('A product photo of juice bottles with no label.'),
    imageSrc: image7,
  },
  {
    promptText: _TL_('A five-star hotel room with a stunning view of the city skyline.'),
    imageSrc: image8,
  },
  {
    promptText: _TL_('An all-inclusive spa treatment setting.'),
    imageSrc: image9,
  },
  {
    promptText: _TL_('A hiking backpack and gear on an adventurous trail with breathtaking views.'),
    imageSrc: image10,
  },
  {
    promptText: _TL_('A trendy cafe table with coffee cups.'),
    imageSrc: image11,
  },
  {
    promptText: _TL_('A beautifully arranged floral bouquet on a table.'),
    imageSrc: image12,
  },
  {
    promptText: _TL_('A beautifully wrapped gift in front of a fireplace.'),
    imageSrc: image13,
  },
  {
    promptText: _TL_('An elegant dining setup for a romantic evening.'),
    imageSrc: image14,
  },
  {
    promptText: _TL_('Refreshing smoothies in elegant glassware.'),
    imageSrc: image15,
  },
  {
    promptText: _TL_('A stylish urban setting with modern decor.'),
    imageSrc: image16,
  },
  {
    promptText: _TL_('A festive living room with a beautifully decorated Christmas tree, featuring branded holiday decor items and cozy products.'),
    imageSrc: image17,
  },
  {
    promptText: _TL_('A winter market stall with festive treats.'),
    imageSrc: image18,
  },
  {
    promptText: _TL_('Beautifully wrapped gift boxes placed under a decorated holiday tree with twinkling lights.'),
    imageSrc: image19,
  },
];

export const AIPromptExamples = samples;
